import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    selectedLayer: {
      fontWeight: 600,
      margin: theme.spacing(-1, 0, -0.6),
    },
    minInfo: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(0.4, 4.5, 0.4, 1.5),
      gap: theme.spacing(1.5),

      '& > span': {
        lineHeight: 0,
        fontWeight: 500,

        '&:nth-child(3)': {
          flex: 1,
          textAlign: 'center',
        },
      },
    },

    comparativeResults: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(1.5),

      '& > h3': {
        fontSize: '1.6rem',
        marginBottom: theme.spacing(0.5),
      },

      '& .MuiTable-root': {
        borderCollapse: 'separate',
        borderSpacing: theme.spacing(0.5),
      },
      '& .MuiTableCell-root': {
        borderBottom: 'none',
      },
    },
    tHead: {
      '& .MuiTableCell-root > p': {
        fontSize: '1.2rem',
        fontWeight: 600,
        lineHeight: '1rem',
      },
    },
    tBody: {
      '& .MuiTableCell-root': {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(0.5, 1.5),
        borderRadius: 5,
        minWidth: '8rem',
        '& > h6': {
          fontWeight: 600,
        },
      },
    },
  }),
)
